import {ModelPrompt} from 'webmodals/model-prompt.es6'

class ConsumerPaymentMethodPrompt extends ModelPrompt {
    constructor($uibModal, $session) {
        super($uibModal);
        this.seed = Object.assign({}, $session);
    }
    getTitle(model, action){return `${action} payment method...`}
    getQueryUrl(model, action){return `QueryConsumerPaymentMethods.json?EncryptedNumber=${model && encodeURIComponent(model.encryptedNumber)}`;}
    getCommandUrl(model, action){ return `${action}ConsumerPaymentMethod.json`;}
    getModalBodyTemplateUrl(model, action){ return `consumer-payment-method-${action === 'Delete' ? 'delete-confirmation' : 'fieldset'}.html`;}
    mapModel(model, action){ 
        var m = Object.assign(model);
        delete m.expiration;
        delete m.expiresOn;
        return m;
    }
}

export default ConsumerPaymentMethodPrompt

angular.module('emun.consumer').service('consumerPaymentMethodPrompt', ConsumerPaymentMethodPrompt);